<template lang="pug">
  v-dialog(v-model="show" persistent width="100%" scrollable fullscreen)
    v-snackbar( v-model="snackbar" :color="snackbarColor" ) {{snackBarText}}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackbar = false")
          v-icon fal fa-times
    v-snackbar(v-model="showError" color="error")
      span {{ errorMessage }}
      v-btn(dark text @click="showError = false")
        v-icon fal fa-times
    v-card.text-center(flat align="center")
      v-row.ma-0(align="center" )
        v-col(cols="12")
          v-card-text.font-weight-bold.title.text-center(align="center" justify="center")  {{$t('profileDialog.accountDeleted')}}
            v-row.ma-0(align="center" )
              v-col(cols="12")
                v-btn(@click="closeDialog" color="primary" ) Rozumiem

</template>

<script lang="ts">
import Vue from 'vue'
import {Action, Getter} from 'vuex-class'
import {
  AUTH_LOG_USER_OUT,
  DELETE_BOARDER,
  ORDER_CONFIRMATION,
} from '@/store/action-types'
import {USER_LOGGED_IN} from '@/store/getter-types'
import {Component, Prop} from 'vue-property-decorator'
import {TranslateResult} from 'vue-i18n'
import i18n from '@/plugins/i18n'
import {CurrentUser} from "@/model/CurrentUser";

function valueIsRequired (v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function validatePhoneNumber (v: string): boolean | TranslateResult {
  if (v) {
    return  /^[+]?[\d\s]+$/.test(v) || i18n.t('validation.phoneNumberMustBeValid')
  }
  return true
}

function passwordLength(v: string): boolean | TranslateResult {
  if (v) {
    return v.length >= 4 || i18n.t('validation.passwordMinimumLength')
  }

  return false
}

@Component
export default class DeleteDialog extends Vue {

  $refs!: {
    form: Vue & { validate: () => boolean }
  }


  private passwordRules: Array<(v: string) => string | boolean | TranslateResult> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired'),
    (v: string) => !!v || i18n.t('validation.valueIsRequiredMessage'),
    (v: string) => (v && v.length > 3)  || i18n.t('validation.passwordMinimumLength'),
    (v: string) => {
      const pattern = /^[a-zA-Z0-9]*$/

      return pattern.test(v) || i18n.t('validation.valueIsRequiredMessage')
    },
  ]
  private isSaveInProgress: boolean = false
  private showError: boolean = false
  private errorMessage: TranslateResult | null = null
  private password: string | null = null
  private saveInProgress: boolean = false
  private snackbar: boolean = false
  private snackBarText: string = ''
  private snackbarColor: string = ''
  private countDown: number = 10
  private timer: any | null = null


  @Action(ORDER_CONFIRMATION) orderConfirmation!: ({ (payload: any): Promise<boolean> })
  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Getter(USER_LOGGED_IN) currentUser!: CurrentUser


  countDownTimer () {
    if (this.countDown > 0) {
      setTimeout(() => {
        this.countDown -= 1
        this.countDownTimer()
      }, 1000)
    } else if (this.countDown < 1) {
      this.closeDialog()
    }
  }

  closeDialog () {
    this.$emit('closeAndLogOut')
  }

  mounted() {
    this.countDownTimer()


  }

}
</script>

<style lang="stylus" scoped>
.card-body
  min-height 200px
  overflow auto

.sloader
  width 100%
.tab
  color red

</style>
